"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SIANewsletterTop = _interopRequireDefault(require("./SIANewsletterTop/SIANewsletterTop"));
var _ArticleList = _interopRequireDefault(require("./ArticleList/ArticleList"));
var _Normen = _interopRequireDefault(require("./Normen/Normen"));
var _Jobs = _interopRequireDefault(require("./Jobs/Jobs"));
var _Formation = _interopRequireDefault(require("./Formation/Formation"));
var _ReferenceGallery = _interopRequireDefault(require("./ReferenceGallery/ReferenceGallery"));
var _JobPortal = _interopRequireDefault(require("./JobPortal/JobPortal"));
var _Events = _interopRequireDefault(require("./Events/Events"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-newsletter {\n  display: flex;\n  max-width: 765px;\n  flex-direction: column;\n  margin: auto; }\n  .sia-newsletter .bottom {\n    display: flex;\n    gap: 16px;\n    justify-content: center;\n    padding-left: 16px;\n    padding-right: 16px; }\n    .sia-newsletter .bottom .left-container {\n      width: 100%;\n      max-width: 455px; }\n    .sia-newsletter .bottom .right-container {\n      width: 100%;\n      max-width: 293px; }\n  .sia-newsletter svg {\n    overflow: initial; }\n  .sia-newsletter .picture-container {\n    padding-bottom: 24px; }\n  .sia-newsletter .downloadlinkbox-container {\n    padding-right: 0px; }\n    .sia-newsletter .downloadlinkbox-container p {\n      width: auto; }\n\n@media (max-width: 42rem) {\n  .sia-newsletter {\n    max-width: 640px; }\n    .sia-newsletter .bottom {\n      flex-wrap: wrap; }\n      .sia-newsletter .bottom .left-container {\n        max-width: 393px;\n        min-width: 230px; }\n      .sia-newsletter .bottom .right-container {\n        max-width: 393px;\n        min-width: 230px; }\n    .sia-newsletter .normen,\n    .sia-newsletter .jobs,\n    .sia-newsletter .jobsPortal {\n      margin-left: 0px; }\n    .sia-newsletter .referenceGallery {\n      border-width: 0px; } }\n";
  const fileName = "SIANewsletter_SIANewsletter";
  const element = document.querySelector("style[data-sass-component='SIANewsletter_SIANewsletter']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const SIANewsletter = _ref => {
  let {
    item,
    lang
  } = _ref;
  const reference_gallery = item.reference_gallery;
  const job_portal = item.job_portal || [];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-newsletter "
  }, /*#__PURE__*/_react.default.createElement(_SIANewsletterTop.default, {
    item: item
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "bottom sia-padding-03-top "
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "left-container"
  }, /*#__PURE__*/_react.default.createElement(_ArticleList.default, {
    item: item,
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(_Formation.default, {
    item: item,
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(_Events.default, {
    newsletter_date: item.send_time[0]?.value?.split(' ')[0],
    event_labels: item.sia_newsletter_labels,
    event_occurrences: item.event_occurrences,
    sia_events: item.sia_events,
    external_events: item.external_events,
    agenda_url: item?.agenda_url,
    lang: lang
  }), reference_gallery?.length > 0 && /*#__PURE__*/_react.default.createElement(_ReferenceGallery.default, {
    label: item.sia_newsletter_labels,
    items: reference_gallery,
    lang: lang
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "right-container "
  }, /*#__PURE__*/_react.default.createElement(_Normen.default, {
    item: item,
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(_Jobs.default, {
    item: item,
    lang: lang
  }), job_portal?.length > 0 && /*#__PURE__*/_react.default.createElement(_JobPortal.default, {
    label: item.sia_newsletter_labels,
    items: job_portal,
    lang: lang
  }))));
};
var _default = exports.default = SIANewsletter;